'use client';

import { useDecisions } from '../../hooks';
import { OneTrustLegacy } from './legacy';

export function OneTrustScripts({ customerKey }: { customerKey: string | undefined }) {
    const isOneTrust = useDecisions('onetrust');

    if (isOneTrust) return null;

    return <OneTrustLegacy customerKey={customerKey} />;
}
